import { render, staticRenderFns } from "./PublicSimulationFeedback.vue?vue&type=template&id=6936f5f8&"
import script from "./PublicSimulationFeedback.vue?vue&type=script&lang=js&"
export * from "./PublicSimulationFeedback.vue?vue&type=script&lang=js&"
import style0 from "./PublicSimulationFeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports